// Toolbar config is now in toolbar-config.js (loaded before Trix initializes)
// This file just loads the extension modules

require("./video-embed");
require("./richtext");
require("./html-embed");
require("./module-inserter");
